export default __webpack_public_path__ + "static/media/game_01_ok.516f3e3e.png";